import Layout from "../components/layout";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React, {useEffect} from "react";
import {AuthContext} from "../contexts/auth";
import {useHistory} from "react-router";

function LogoutView() {
    const [state, dispatch] = React.useContext(AuthContext);
    let history = useHistory();

    useEffect(() => {
        if (!state.auth) {
            history.push("/")
            return
        }


        dispatch({
            type: "logout"
        })

        let int = setTimeout(() => {
            history.push("/")
        }, 2500)

        return () => {
            clearInterval(int)
        }
    }, [])

    return (
        <Layout>
            <div className="card no-orders-card shadow">
                <div className="card-body d-flex flex-column justify-content-center align-items-center text-muted">
                    <FontAwesomeIcon className="fs-1 my-3" icon={["fas", "hand-spock"]}/>
                    <div>Bye, have a great time...</div>
                </div>
            </div>
        </Layout>
    )
}

export default LogoutView